export enum LorenError {
  "NOT_FOUND" = "NOT_FOUND",
  "FORBIDDEN" = "FORBIDDEN",
  "SERVICE_ERROR" = "SERVICE_ERROR",
}
